import { defaultThemeColor } from '@/utils/constant'
export const legalSetting = {
  text: '我已阅读并同意',
  agreementName: '法律相关协议',
  agreementUrl: '',
  defaultCheck: true
}
/** *
 * 1. 默认状态下 显示:标题、前言、题号; 隐藏:头图、法律协议、提交按钮、结束页按钮、版权、结束页不显示提示
 *
 */

export const advanceMinxin = {
  data() {
    return {
      legal: {}
    }
  },
  computed: {
    /** *
     *  key:addHeadPig,addLegalAgreement,hideSubmitButton,
     * hideEndPageButton,hideCopyRightOrAD,lastPage
     *  显隐控制：头图、法律协议、提交按钮、结束页按钮、版权、结束页不显示提示
     */
    isShowCtrl() {
      // eslint-disable-next-line func-names
      return function(key) {
        // hideTitle,hidePrefix,hideQuestionNumber
        // 默认状态下
        if (!this.survey.advanceSettingFlag) {
          return !!'hideTitle,hidePrefix,hideQuestionNumber,hideSubmitButton,hideEndPageButton,hideCopyRightOrAD'.includes(key)
        }
        let setting = this.survey.surveyAdvanceSettingObj || {}
        switch (key) {
          case 'lastPage':
            // 设置显示提交按钮&&（url||toast）结束页显示提示信息
            if (this.survey && setting) {
              const obj = setting
              if (!obj.hideSubmitButton && obj.submitButtonSetting &&
                (obj.submitButtonSetting.url || obj.submitButtonSetting.toast)) {
                return true
              }
            }
            return false
          case 'addHeadPig':
          case 'addLegalAgreement':
            // 头图、法律协议 选中：显示，取消：隐藏
            if (this.survey && setting) {
              return setting[key]
            }
            return false
          default:
            // 默认 选中：隐藏，取消：显示（提交按钮、结束页按钮、版权）
            if (this.survey && setting) {
              return !setting[key]
            }
            return true
        }
      }
    },
    endPageText: function() {
      let str = '我也要创建问卷'
      let setting = this.survey.surveyAdvanceSettingObj || {}
      if (this.survey.advanceSettingFlag && setting && !setting.hideEndPageButton && setting.suffixButtonSetting) {
        return setting.suffixButtonSetting.buttonText || str
      }
      return str
    },
    submitBtnText: function() {
      let text = '提交', radius = 0
      let setting = this.survey.surveyAdvanceSettingObj || {}
      if (this.survey.advanceSettingFlag && setting && !setting.hideSubmitButton && setting.submitButtonSetting) {
        text = setting.submitButtonSetting.buttonText || text
        radius = setting.submitButtonSetting.buttonAngle || 0
      }
      return { text, radius }
    },
    isDisabled() {
      let setting = this.survey.surveyAdvanceSettingObj || {}
      if (this.survey.advanceSettingFlag && setting && setting.addLegalAgreement && setting.legalAgreementSetting && !setting.legalAgreementSetting.defaultCheck) {
        return true
      }
      return false
    },
    isBottom() {
      let setting = this.survey.surveyAdvanceSettingObj || {}
      if (this.survey.advanceSettingFlag && setting && !setting.hideSubmitButton && setting.submitButtonSetting && setting.submitButtonSetting.buttonBottom) {
        return true
      }
      return false
    }
  },
  methods: {
    setLegal() {
      let agreement = legalSetting
      let setting = this.survey.surveyAdvanceSettingObj || {}
      if (this.survey.advanceSettingFlag && setting && setting.addLegalAgreement) {
        Object.assign(agreement, setting.legalAgreementSetting)
      }
      this.legal = agreement
    },
    showLegalModal() {
      this.$refs.popup.show()
    },
    hideLegalModal() {
      this.$refs.popup.hide()
    },
    openLegalModal() {
      if (this.styleMode() === 'pc') {
        window.open(this.survey.surveyAdvanceSettingObj.legalAgreementSetting.agreementUrl, '_blank')
      } else {
        this.showLegalModal()
      }
    },
    styleMode() {
      let width = document.body.clientWidth
      if (width <= 600) {
        return 'mobile'
      }
      return 'pc'
    },
    endUrl() {
      let hasEndPage = true
      let setting = {}
      if (this.survey.advanceSettingFlag && !this.survey.surveyAdvanceSettingObj.hideSubmitButton) {
        setting = this.survey.surveyAdvanceSettingObj.submitButtonSetting || {}
        if (setting.url || setting.toast) {
          hasEndPage = false
        }
      }
      let mode = this.styleMode()
      if (!hasEndPage) {
        if (setting.toast) {
          if (mode === 'pc') {
            this.$message({
              message: setting.toastText,
              type: 'success'
            })
          } else {
            this.$createToast({
              type: 'correct',
              txt: setting.toastText
            }).show()
          }
        }
        if (setting.url) {
          if (setting.toast) {
            setTimeout(() => {
              window.location.href = setting.url
            }, 1000)
          } else {
            window.location.href = setting.url
          }
        }
      } else {
        if (this.activePage < this.survey.pages.length) {
          this.activePage++
          document.title = '提交成功'
        }
      }
    }
  }
}

export const buttonSetting = {
  buttonText: '',
  url: '',
  toast: false,
  toastText: '',
  buttonBottom: false
}
export const advanceSettingFlag = {
  hideTitle: false,
  hidePrefix: false,
  hideQuestionNumber: false,
  addLegalAgreement: false,
  hideSubmitButton: false,
  hideCopyRightOrAD: false,
  hideEndPageButton: false,
  addHeadPig: false,
  headPig: '',
  themeColor: defaultThemeColor
}
export const activitySettingFlag = {
  hideTitle: true,
  hidePrefix: true,
  hideQuestionNumber: true,
  hideCopyRightOrAD: true
}

function deepClone(initObj, curObj) {
  return Object.assign({}, initObj, curObj || {})
}
export function genAdvanceSettingFlag(params, isActivity) {
  const {
    submitButtonSetting,
    suffixButtonSetting,
    legalAgreementSetting,
    ...args
  } = params || {}
  let defaultFlag = advanceSettingFlag
  if (isActivity) {
    defaultFlag = Object.assign({}, defaultFlag, activitySettingFlag)
  }
  return {
    ...deepClone(defaultFlag, args),
    submitButtonSetting: deepClone(buttonSetting, submitButtonSetting),
    suffixButtonSetting: deepClone(buttonSetting, suffixButtonSetting),
    legalAgreementSetting: deepClone(legalSetting, legalAgreementSetting)
  }
}



// WEBPACK FOOTER //
// ./src/utils/advanceMinxin.js